'use strict';

angular.module('invitations')
    .controller('InvitationsTableItemController', ['InvitationsManager', 'ShareCrfApiErrorCodes', function(InvitationsManager, ShareCrfApiErrorCodes) {
        var vm = this;

        vm.studyInfo = {};
        vm.errorMessage = null;

        vm.ready = false;
        vm.error = false;
        vm.running = false;


        vm.$onInit = function() {
            InvitationsManager.getStudyInfo(vm.item.study.subdomain)
                .then(function(studyInfo) {
                    vm.studyInfo = studyInfo;
                    vm.ready = true;
                })
                .catch(function(error) {
                    vm.error = true;
                    vm.ready = true;
                });

            vm.acceptInvitation = function() {
                vm.running = true;
                vm.errorMessage = null;

                return InvitationsManager.acceptInvitation(vm.item)
                    .then(function() {
                        vm.running = false;
                    })
                    .catch(function(error) {
                        vm.running = false;
                        vm.errorMessage = ShareCrfApiErrorCodes.getHumanReadableMessage(error);
                    });
            };

            vm.rejectInvitation = function() {
                vm.running = true;
                vm.errorMessage = null;

                return InvitationsManager.rejectInvitation(vm.item)
                    .then(function() {
                        vm.running = false;
                    })
                    .catch(function(error) {
                        vm.running = false;
                        vm.errorMessage = ShareCrfApiErrorCodes.getHumanReadableMessage(error);
                    });
            };
        };
    }]);
